function injectStyle (ssrContext) {
  require("!!vue-style-loader!css-loader!../../../node_modules/vue-loader/lib/style-compiler/index?{\"vue\":true,\"id\":\"data-v-1f56a4f2\",\"scoped\":true,\"hasInlineConfig\":false}!../../../node_modules/vue-loader/lib/selector?type=styles&index=0!./purchaseApproverDetails.vue")
}
var Component = require("!../../../node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!../../../node_modules/vue-loader/lib/selector?type=script&index=0!./purchaseApproverDetails.vue"),
  /* template */
  require("!!../../../node_modules/vue-loader/lib/template-compiler/index?{\"id\":\"data-v-1f56a4f2\",\"hasScoped\":true}!../../../node_modules/vue-loader/lib/selector?type=template&index=0!./purchaseApproverDetails.vue"),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-1f56a4f2",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./src/component/common/purchaseApproverDetails.vue
// module id = 2037
// module chunks = 0